module.exports = __webpack_public_path__ + "resources/images/asn_bank-5ea8a9e872fc4b0bdcb7ac6370ca4bed-cache.png";